import { render, staticRenderFns } from "./RbxToolbar.vue?vue&type=template&id=2d733d87&scoped=true&"
import script from "./RbxToolbar.vue?vue&type=script&lang=js&"
export * from "./RbxToolbar.vue?vue&type=script&lang=js&"
import style0 from "./RbxToolbar.vue?vue&type=style&index=0&id=2d733d87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d733d87",
  null
  
)

component.options.__file = "RbxToolbar.vue"
export default component.exports